export const SyncContextTypeValues = {
    PRODUCT: 'product',
    ERP_CODE: 'erp_code',
} as const;
export type SyncContextTypeValue = typeof SyncContextTypeValues[keyof typeof SyncContextTypeValues];

export class SyncContextType {

    private static readonly VALID_VALUES: string[] = Object.values(SyncContextTypeValues);

    private readonly _value: SyncContextTypeValue;

    public constructor(value: SyncContextTypeValue) {
        if (!this.isValid(value)) {
            throw new Error(`Invalid SyncContextType value: ${value}`);
        }
        this._value = value;
    }

    private isValid(value: string): boolean {
        return SyncContextType.VALID_VALUES.includes(value);
    }

    public get value(): SyncContextTypeValue {
        return this._value;
    }

    public isProduct(): boolean {
        return this._value === SyncContextTypeValues.PRODUCT;
    }

    public isErpCode(): boolean {
        return this._value === SyncContextTypeValues.ERP_CODE;
    }

}
